<template>
  <b-form-group id="rich-editor-unmwhm" :label="properties.label">
    <smart-text-input id="rich-editor-d7hwia"
      v-model="propertyValue"
      :enableMentions="false"
      :showSubmitButton="false"
      backgroundColor="#FFF"
      :showFullToolBar="true"
    />
  </b-form-group>
</template>

<script>
import SmartTextInput from "../../controls/SmartTextInput.vue";
export default {
  name: "RichEditorPropertyType",
  components: { SmartTextInput },
  props: ["properties", "property", "value"],
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
      }
    }
  }
};
</script>
